import { downloadSpecialCalculationCostCsv } from '@/services/admin/special-calculation-costs';
import { SpecialCalculationCostQuery } from '@/types/special-calculation-cost';
import { getApiErrorMessage } from '@/utils';
import { CSV_ERROR_MESSAGE, CSV_SUCCESS_MESSAGE } from '@/constants/messages';
import { useMutation } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import useAppToast from '../useAppToast';

export const useSpecialCalculationCostCsv = () => {
  const { site } = useParams<{ site: string }>();
  const currentSite = site ?? 'medix';
  const toast = useAppToast();

  return useMutation({
    mutationFn: (params?: SpecialCalculationCostQuery) =>
      downloadSpecialCalculationCostCsv(currentSite, params),
    onSuccess: () => {
      toast.success(CSV_SUCCESS_MESSAGE);
    },
    onError: err => {
      toast.error(getApiErrorMessage(err, CSV_ERROR_MESSAGE));
    },
  });
};
